import gql from 'graphql-tag';

export const allowCompanyDelete = gql`
  query allowCompanyDelete($id: String!) {
    allowCompanyDelete(id: $id) {
      value
    }
  }
`;
